import React, { useEffect, useRef } from 'react';
import './WhyusEfficiency.css';

const efficiencyCards = [
  {
    title: "REDUCE COST",
    description: "Reduce your development cost by up to 50%"
  },
  {
    title: "LOWER TTM",
    description: "Reduce your time to market by up to 70%"
  },
  {
    title: "RAMP UP IN 1 WEEK",
    description: "Start your project in one week"
  },
  {
    title: "CUT RECRUITMENT COST",
    description: "Eliminate any overhead and recruitment cost"
  },
  {
    title: "ADAPT YOUR TEAM",
    description: "Scale up or down your team as you require"
  },
  {
    title: "GET EXPERTS",
    description: "Find the exact right expert for the job"
  }
];

const WhyusEfficiency = () => {
  const cardRefs = useRef([]);
  const previousScrollY = useRef(window.scrollY);
  const yOffsets = useRef(Array(efficiencyCards.length).fill(0));
  const isMobile = useRef(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      isMobile.current = window.innerWidth <= 768;
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isMobile.current) return; // Skip animation setup on mobile

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const deltaY = currentScrollY - previousScrollY.current;
      const direction = deltaY > 0 ? 'down' : 'up';

      cardRefs.current.forEach((ref, index) => {
        if (!ref) return;

        const isLeft = index % 3 === 0;
        const isRight = index % 3 === 2;

        if (isLeft || isRight) {
          const change = direction === 'down' ? -1.5 : 1.5;
          let newOffset = yOffsets.current[index] + change;
          newOffset = Math.max(-40, Math.min(40, newOffset));
          yOffsets.current[index] = newOffset;

          ref.style.transform = `translate3d(0, ${newOffset}px, 0)`;
        }
      });

      previousScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="whyus-efficiency-section" id="whyus-efficiency">
      <div className="container">
        <div className="whyus-efficiency-header">
          <h2 className="black-title1">IMPROVING BUSINESS EFFICIENCY</h2>
          <p className="whyus-efficiency-subtitle">
            By choosing to run your development work with Lattice Labs, you will be able to:
          </p>
        </div>

        <div className="whyus-efficiency-grid">
          {efficiencyCards.map((card, index) => (
            <div
              key={index}
              ref={(el) => (cardRefs.current[index] = el)}
              className="efficiency-card"
            >
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyusEfficiency;